export default "__VITE_ASSET__BOJ26Uc6__"